import { createContext, useContext } from "react";

export interface IntercomContextValue {
  unreadCount: number;
  showIntercom: () => void;
  isPending: boolean;
  isError: boolean;
}

export const IntercomContext = createContext<IntercomContextValue | null>(null);

export const useIntercom = () => {
  const context = useContext(IntercomContext);
  if (!context) {
    throw new Error("useIntercom must be used within IntercomProvider");
  }
  return context;
};
